<template>
  <div class="container py-5" style="min-height:70vh">
    <h2>Cjenik usluga</h2>
    <div class="container py-3">
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
              <thead class="thead-dark">
                  <tr>
                      <th scope="col">Usluga</th>
                      <th scope="col" class="text-right">Cijena</th>
                      <th scope="col" class="text-right">
                          <small class="d-block text-light">
                              Cijena 10.09.2026.
                          </small>
                      </th>
                  </tr>
              </thead>
              <tbody>
                <tr>
                      <td>Razvoj web aplikacije</td>
                      <td class="text-nowrap text-right">30,00 € / sat</td>
                      <td class="text-nowrap text-right">30,00 € / sat</td>
                  </tr>
                  <tr>
                      <td>Razvoj jednostavne web stranice</td>
                      <td class="text-nowrap text-right">15,00 € / sat</td>
                      <td class="text-nowrap text-right">15,00 € / sat</td>
                  </tr>
                  <tr>
                      <td>Održavanje web aplikacije</td>
                      <td class="text-nowrap text-right">150,00 € / god.</td>
                      <td class="text-nowrap text-right">150,00 € / god.</td>
                  </tr>
                  <tr>
                      <td>Održavanje jednostavne web stranice</td>
                      <td class="text-nowrap text-right">50,00 € / god.</td>
                      <td class="text-nowrap text-right">50,00 € / god.</td>
                  </tr>
                  <tr>
                      <td>Hosting web aplikacije</td>
                      <td class="text-nowrap text-right">100,00 € / god.</td>
                      <td class="text-nowrap text-right">100,00 € / god.</td>
                  </tr>
                  <tr>
                      <td>Hosting jednostavne web stranice</td>
                      <td class="text-nowrap text-right">50,00 € / god.</td>
                      <td class="text-nowrap text-right">50,00 € / god.</td>
                  </tr>
                  <tr>
                      <td>Nadogradnja postojeće web aplikacije</td>
                      <td class="text-nowrap text-right">30,00 € / sat</td>
                      <td class="text-nowrap text-right">30,00 € / sat</td>
                  </tr>
                  <tr>
                      <td>Nadogradnja postojeće web stranice</td>
                      <td class="text-nowrap text-right">20,00 € / sat</td>
                      <td class="text-nowrap text-right">20,00 € / sat</td>
                  </tr>
                  <tr>
                      <td>Registracija i obnova domene</td>
                      <td class="text-nowrap text-right">15,00 € / god.</td>
                      <td class="text-nowrap text-right">15,00 € / god.</td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="table-responsive py-4">
            <h4>Program Prehrane</h4>
            <table class="table table-bordered table-hover">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Usluga / paket</th>
                        <th scope="col" class="text-right">Cijena</th>
                        <th scope="col" class="text-right">
                            <small class="d-block text-light">
                                Cijena 10.09.2026.
                            </small>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-light">
                        <th colspan="3">Program Prehrane – START</th>
                    </tr>
                    <tr>
                        <td>1 mjesec</td>
                        <td class="text-nowrap text-right">10,00 €</td>
                        <td class="text-nowrap text-right">10,00 €</td>
                    </tr>
                    <tr>
                        <td>3 mjeseca</td>
                        <td class="text-nowrap text-right">27,00 €</td>
                        <td class="text-nowrap text-right">27,00 €</td>
                    </tr>
                    <tr>
                        <td>6 mjeseci</td>
                        <td class="text-nowrap text-right">48,00 €</td>
                        <td class="text-nowrap text-right">48,00 €</td>
                    </tr>
                    <tr>
                        <td>1 godina</td>
                        <td class="text-nowrap text-right">84,00 €</td>
                        <td class="text-nowrap text-right">84,00 €</td>
                    </tr>
                    <tr>
                        <td>2 godine</td>
                        <td class="text-nowrap text-right">144,00 €</td>
                        <td class="text-nowrap text-right">144,00 €</td>
                    </tr>
                    <tr>
                        <td>3 godine</td>
                        <td class="text-nowrap text-right">180,00 €</td>
                        <td class="text-nowrap text-right">180,00 €</td>
                    </tr>
                    <tr class="table-light">
                        <th colspan="3">Program Prehrane – STANDARD</th>
                    </tr>
                    <tr>
                        <td>1 mjesec</td>
                        <td class="text-nowrap text-right">18,00 €</td>
                        <td class="text-nowrap text-right">18,00 €</td>
                    </tr>
                    <tr>
                        <td>3 mjeseca</td>
                        <td class="text-nowrap text-right">48,60 €</td>
                        <td class="text-nowrap text-right">48,60 €</td>
                    </tr>
                    <tr>
                        <td>6 mjeseci</td>
                        <td class="text-nowrap text-right">86,40 €</td>
                        <td class="text-nowrap text-right">86,40 €</td>
                    </tr>
                    <tr>
                        <td>1 godina</td>
                        <td class="text-nowrap text-right">151,20 €</td>
                        <td class="text-nowrap text-right">151,20 €</td>
                    </tr>
                    <tr>
                        <td>2 godine</td>
                        <td class="text-nowrap text-right">259,20 €</td>
                        <td class="text-nowrap text-right">259,20 €</td>
                    </tr>
                    <tr>
                        <td>3 godine</td>
                        <td class="text-nowrap text-right">324,00 €</td>
                        <td class="text-nowrap text-right">324,00 €</td>
                    </tr>
                    <tr class="table-light">
                        <th colspan="3">Program Prehrane – PREMIUM</th>
                    </tr>
                    <tr>
                        <td>1 mjesec</td>
                        <td class="text-nowrap text-right">32,00 €</td>
                        <td class="text-nowrap text-right">32,00 €</td>
                    </tr>
                    <tr>
                        <td>3 mjeseca</td>
                        <td class="text-nowrap text-right">86,40 €</td>
                        <td class="text-nowrap text-right">86,40 €</td>
                    </tr>
                    <tr>
                        <td>6 mjeseci</td>
                        <td class="text-nowrap text-right">153,60 €</td>
                        <td class="text-nowrap text-right">153,60 €</td>
                    </tr>
                    <tr>
                        <td>1 godina</td>
                        <td class="text-nowrap text-right">268,80 €</td>
                        <td class="text-nowrap text-right">268,80 €</td>
                    </tr>
                    <tr>
                        <td>2 godine</td>
                        <td class="text-nowrap text-right">460,80 €</td>
                        <td class="text-nowrap text-right">460,80 €</td>
                    </tr>
                    <tr>
                        <td>3 godine</td>
                        <td class="text-nowrap text-right">576,00 €</td>
                        <td class="text-nowrap text-right">576,00 €</td>
                    </tr>
                    <tr class="table-light">
                        <th colspan="3">Dodatne usluge</th>
                    </tr>
                    <tr>
                        <td>Tehnička podrška 24/7/365 – 1 godina</td>
                        <td class="text-nowrap text-right">240,00 €</td>
                        <td class="text-nowrap text-right">240,00 €</td>
                    </tr>
                    <tr>
                        <td>Edukacija – 1 sat</td>
                        <td class="text-nowrap text-right">80,00 €</td>
                        <td class="text-nowrap text-right">80,00 €</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
      <div class="text-right py-5">
        <router-link :to="'/cijene-csv'" :title="'Cijene CSV'">
            <span class="nav-link">
            <icon :name="'euro-sign'"></icon>
            Cijene CSV
          </span>
        </router-link>
      </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: "%s | Cjenik usluga",
    meta: [
      {
        name: "description",
        content:
          "IG PROG, OBRT ZA RAČUNALNO PROGRAMIRANJE  - Cjenik usluga",
      },
    ],
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/prices.vue